import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=1c3c8a97&scoped=true"
import script from "./Button.js?vue&type=script&lang=js&external"
export * from "./Button.js?vue&type=script&lang=js&external"
import style0 from "./Button.scss?vue&type=style&index=0&id=1c3c8a97&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3c8a97",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotIcon: require('/home/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Atoms/Icon/Icon.vue').default})
